import i from 'i18next'

import { FormGroup, Input, Label } from '~/components/unform'

const Search = () => (
  <FormGroup>
    <Label isRequired>{i.t('rm:Term')}</Label>
    <Input required name="term" placeholder={i.t('rm:Term')} />
  </FormGroup>
)

export default Search
